module.exports = __webpack_public_path__ + "static/media/RemoteWork.b8d39129.svg";